<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-quote`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.835 8.105c.382.041.58.359.513.833l-.358 2.518c-.08.557-.421.625-.774.605l-.082-.006c-6.729-.588-11.282 4.127-11.922 14.568a8 8 0 11-3.85 8.074c-.311-.773-.358-3.501-.362-4.775v-.35c.018-7.008 1.652-12.592 4.287-16.208 2.922-4.011 7.253-5.837 12.548-5.26zm21.276 0c.381.041.58.359.513.833l-.36 2.518c-.078.557-.42.625-.773.605l-.081-.006c-6.73-.588-11.283 4.127-11.923 14.568a8 8 0 11-3.85 8.074c-.311-.773-.357-3.501-.362-4.775v-.35c.018-7.008 1.652-12.592 4.287-16.208 2.922-4.011 7.253-5.837 12.549-5.26z"/></svg>
</template>
<script>

export default {
  name: 'IconQuote',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
